import { getLocalKeywordSuggestions } from './getKeywordSuggestions';
import { getLocalPeopleSuggestions } from './getPeopleSuggestions';
import { MAX_SERVER_SUGGESTION_OF_KIND } from '../../constants';
import { Suggestion } from 'owa-search-service/lib/data/schema/SuggestionSet';

/**
 * This function gets zero query suggestions, which currently includes keyword
 * suggestions from search history, as well as people suggestions from the
 * recipient cache. When these are fetched and merged, we dispatch the
 * "setSuggestions" action from owa-search to set them in the store.
 */
export default function getZeroQuerySuggestions(): Promise<Suggestion[]> {
    const localKeywordSuggestions: Suggestion[] =
        getLocalKeywordSuggestions(MAX_SERVER_SUGGESTION_OF_KIND) || [];

    const localPeopleSuggestions: Suggestion[] =
        getLocalPeopleSuggestions(MAX_SERVER_SUGGESTION_OF_KIND) || [];

    return Promise.resolve([localKeywordSuggestions, localPeopleSuggestions]).then(
        localSuggestionSets => {
            // Merge sets of keyword and people suggestions into single set.
            return localSuggestionSets.reduce((accumulator, localSuggestionSet) =>
                accumulator.concat(localSuggestionSet)
            );
        }
    );
}
